import React from "react";
import QuickTaleDetailsContainer from "../../modules/OrganizationQuickTales/containers/QuickTaleDetailsContainer/QuickTaleDetailsContainer";

const QuickTaleDetails = () => {
  return <QuickTaleDetailsContainer />;
};

export default QuickTaleDetails;
